import { Divider, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import DeformationFieldPanel from '~/components/dvf/DeformationFieldPanel';
import { useDeformationDisplayScope } from '~/hooks/viewer/useDeformationDisplayScope';
import { useSelectedDeformationField } from '~/hooks/viewer/useSelectedDeformationField';

export default function RegistrationDeformationSection() {
    const field = useSelectedDeformationField();
    useDeformationDisplayScope(!!field);

    return (
        <Stack
            spacing={1}
            pt={1}
            data-testid="registration-deformation-section"
        >
            <Divider />
            {field ? (
                <DeformationFieldPanel field={field} />
            ) : (
                <Typography
                    fontSize={11}
                    color="text.secondary"
                    data-testid="registration-deformation-unavailable"
                >
                    <FormattedMessage id="registration.deformation.unavailable" />
                </Typography>
            )}
        </Stack>
    );
}
